module.exports = __webpack_public_path__ + "02_long_brown.e4c9afb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_long_brown.png
// module id = K5L/
// module chunks = 0